import React from 'react';
import Workbook from 'react-excel-workbook';
import exportIcon from '../../../../assets/icons/export.svg';
import { ExportPrint, IconPadding, StyleLessButtons } from './styles';
import moment from 'moment';
import { amountFormatter } from '../../utils';
import { formatAmount } from '../../../../utils/commonUtil';
import PropTypes from "prop-types";
import { exportExcelTableData } from "../../../../services/apiServices";
import { getPrimaryAccount } from "../../../../utils/sessionUtil";

const WorkbookSheet = Workbook.Sheet;

function renderData(data) {
  if (data) {
    return data;
  }
  return '-';
}

function renderName(firstName, lastName) {
  if (firstName === null && lastName === null) {
    return null;
  }
  return `${firstName ? firstName + ' ' : ''}${lastName ? lastName + ' ' : ''}`;
}

function renderAmount(data) {
  if (data) {
    return formatAmount(data);
  }
  return amountFormatter(0);
}

function renderDate(data) {
  if (data) {
    return moment(data).format('L');
  }
  return '-';
}

function renderPercent(data, type) {
  if (data) {
    const index = data.findIndex(x => x.poolName === type);
    if (index === -1) {
      return '-';
    }
    return `${data[index].percentShare}%`;
  }
  return '-';
}

function exportExcelAdv(props){
  let data ;
  props.handleExportAnalytics('export', '', 'Export')
  data = props.sFArray ? props.sFArray : props.IntialArray;
  let url = `/donor-portal/api/account/${getPrimaryAccount().userId}/exportFADashboard`;
  return exportExcelTableData(url, data, "Advisor Detail");
}

const Exporter = props => {
  const updatedData = props.data;
  for (let itr = 0; itr < updatedData.length; itr++) {
    let pools = [...updatedData[itr].investmentAllocation.investmentPools];
    for (let i = 0; i < pools.length; i++) {
      var regex = /\s(select)$/i;
      if (regex.test(pools[i].poolName)) {
        const selectChecker = pools[i].poolName.split(' ');
        selectChecker.pop();
        const result = selectChecker.join(' ');
        pools[i].poolName = result;
      }
      let roundedVal = parseFloat(pools[i].percentShare).toFixed(2);
      pools[i].percentShare = roundedVal;
    }
    updatedData[itr].investmentAllocation.investmentPools = pools;
  }

  const exportData = [];
  exportData.push(
    <StyleLessButtons>
           <IconPadding primary='true'>
             <img alt='export advisor' src={exportIcon} />
             <ExportPrint
             onClick={() => exportExcelAdv(props)}
             data-test='fa-export-button'
            >
              EXPORT
            </ExportPrint>
          </IconPadding>
        </StyleLessButtons>
  );
  return exportData;
};
Exporter.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    accountName:PropTypes.string.isRequired,
    accountNumber:PropTypes.string.isRequired,
    clientFirstName:PropTypes.string,
    clientLasttName:PropTypes.string,
    clientMiddleName:PropTypes.string,
    clientPrefix:PropTypes.string,
    clientSuffix:PropTypes.string,
    currentBalance:PropTypes.number,
    dateOpened:PropTypes.number,
    investmentAllocation:PropTypes.object,
    lastContributionDate:PropTypes.number,
    lastExchangeDate:PropTypes.number,
    lastGrantDate:PropTypes.number,
    pendingContribution:PropTypes.bool,
    pendingExchange:PropTypes.bool,
    pendingGrant:PropTypes.bool,
    role:PropTypes.string,
    saFirstName:PropTypes.string,
    saLastName:PropTypes.string,
    saMiddleName:PropTypes.string,
    saPrefix:PropTypes.string,
    saSuffix:PropTypes.string,
    state:PropTypes.string,
    ytd:PropTypes.object
  })),
  handleExportAnalytics:PropTypes.func
};
export default Exporter;
